enum ShareDesignCardStateEnum {
	default = 'default',
	sendByEmail = 'sendByEmail',
	getDesignCode = 'getDesignCode',
	getLink = 'getLink',
	qrCode = 'qrCode'
}

export default ShareDesignCardStateEnum;
